import Services from './base-services'

const service = new Services('gamification')
import mapParameters from '../utils/map-parameters'

export default {
    getUserGameStatsByUser(userId: number | string) {
        const params = mapParameters({
            userId: userId ? userId : null,
        })
        return service.get('getUserGameStatsByUser', params)
    },
    confirmAction(userId: any, coins: any) {
        return service.post(`confirmAction?userId=${userId}&coins=${coins}`)
    },
}
